import "react-native-reanimated";
import { AnonymousWidgetPos } from "../types";
import { isHit } from "../worklets/isHit";

const initialColumn = Array(4).fill([0, 1, 2, 3, 4, 5, 6, 7]);

export function widgetToOneByOnePositions(widget: AnonymousWidgetPos) {
  "worklet";

  const from = widget.y * 2 + widget.x;
  const to = from + widget.h * widget.w;
  return Array(to - from)
    .fill("")
    .map((_, i) => from + i);
}

function oneByOnePositionsToWidgetPosition(group: number[], c: number) {
  "worklet";
  return {
    c,
    x: group[0] % 2,
    y: Math.floor(group[0] / 2),
    w: 2 - (group.length % 2),
    h: Math.max(Math.floor(group.length / 2), 1),
  };
}

export function findEmptyOneByOnePositionsColumn(
  column: AnonymousWidgetPos[],
  c: number,
  numberOfRows: number = 4
) {
  "worklet";
  return column.reduce(
    (result: number[], value: AnonymousWidgetPos) =>
      result.filter((a) => {
        return !isHit({ c, x: a % 2, y: Math.floor(a / 2), h: 1, w: 1 }, value);
      }),
    Array(numberOfRows * 2)
      .fill(0)
      .map((_, i) => i)
  );
}

function findEmptyOneByOnePositions(positions: AnonymousWidgetPos[]) {
  "worklet";
  return positions.reduce((result: number[][], value: AnonymousWidgetPos) => {
    const b = result.map((column, c) =>
      value.c !== c
        ? column
        : column.filter((a) => {
            const hit = isHit(
              { c, x: a % 2, y: Math.floor(a / 2), h: 1, w: 1 },
              value
            );
            return !hit;
          })
    );
    return b;
  }, initialColumn);
}

export function groupOneByOnePositions(positions: number[]) {
  "worklet";
  const grouped = positions.reduce(
    (result, value, index, array) => {
      const even = value % 2 === 0;
      if (!even && array[index - 1] !== value - 1) {
        return [...result, [value], []];
      } else if (even && array[index + 1] !== value + 1) {
        return [...result, [value], []];
      } else if (even && array[index - 1] !== value - 1) {
        return [...result, [value]];
      } else {
        return result.map((group, i) =>
          i === result.length - 1 ? [...group, value] : group
        );
      }
    },
    [[]] as number[][]
  );
  return grouped;
}

export function findEmptyPositions(positions: AnonymousWidgetPos[]) {
  "worklet";
  return findEmptyOneByOnePositions(positions).flatMap(
    (column, columnIndex) => {
      const ep = groupOneByOnePositions(column).flatMap((group) =>
        group.length === 0
          ? []
          : [oneByOnePositionsToWidgetPosition(group, columnIndex)]
      );
      return ep;
    }
  );
}
